import { useSelector } from "react-redux";
import Template from "../../../../components/AssetManagement/Design/Templates/Template";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissionsDesign } from "../CheckPermission/CheckDesignPermissions";
import Page404 from "../../../../components/Page404/Page403";

function TemplatesScreen(userToken: any) {
  const oauthTokenHeader = userToken?.userToken;
  const Websiteresponse = userToken?.response;
  const userData = useSelector(selectUserData);
  const hasViewTemplateNotesPermission = CheckPermissionsDesign(
    userData?.data?.products,
    "view_template"
  );

  return (
    <div>
      {hasViewTemplateNotesPermission ? (
        <Template
          oauthTokenHeader={oauthTokenHeader}
          response={Websiteresponse}
        />
      ) : (
        <Page404 />
      )}
    </div>
  );
}

export default TemplatesScreen;
